/* Program Name: customerAPI.js
 **  Description: a collection of functions that handle the direct AJAX calls
 **               for all things Customers.
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-12-14  STT  Initial program
 *********************************************************************************/

/**importing the baseurl from Axios */
import { setData } from '../../API/generalAPI'
import TS from '../../API/TS'

/** Get Customers =>
 * AJAX call to get all the Roles
 */
export const getMyAccount = () => {
  return TS.post('/user/my_account_rdr', setData())
}

/** Get Customers =>
 * AJAX call to get all the Roles
 */
export const updatePassword = (password, newPassword) => {
  return TS.post(
    '/user/my_account_upd',
    setData({
      ttRequest: [
        { mode: 'password', oldPass: password, newPass: newPassword },
      ],
    })
  )
}
